
import React from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { CheckCircle, AlertTriangle, AlertCircle, Signal, Activity, Database } from 'lucide-react';

interface DeviceStatusCardsProps {
  data: {
    online: number;
    warning: number;
    critical: number;
    offline: number;
    totalReadings?: number;
    dataTransferred?: number;
  };
  type: 'smartMeters' | 'gateways';
}

const DeviceStatusCards: React.FC<DeviceStatusCardsProps> = ({ data, type }) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-5 gap-4 mb-6">
      <Card>
        <CardContent className="p-4">
          <div className="flex justify-between items-start">
            <div>
              <p className="text-sm font-medium">Online</p>
              <h3 className="text-2xl font-bold mt-1">{data.online}</h3>
            </div>
            <div className="rounded-full bg-green-100 p-2 dark:bg-green-900/30">
              <CheckCircle className="h-5 w-5 text-green-600 dark:text-green-400" />
            </div>
          </div>
        </CardContent>
      </Card>
      
      <Card>
        <CardContent className="p-4">
          <div className="flex justify-between items-start">
            <div>
              <p className="text-sm font-medium">Warning</p>
              <h3 className="text-2xl font-bold mt-1">{data.warning}</h3>
            </div>
            <div className="rounded-full bg-amber-100 p-2 dark:bg-amber-900/30">
              <AlertTriangle className="h-5 w-5 text-amber-600 dark:text-amber-400" />
            </div>
          </div>
        </CardContent>
      </Card>
      
      <Card>
        <CardContent className="p-4">
          <div className="flex justify-between items-start">
            <div>
              <p className="text-sm font-medium">Critical</p>
              <h3 className="text-2xl font-bold mt-1">{data.critical}</h3>
            </div>
            <div className="rounded-full bg-red-100 p-2 dark:bg-red-900/30">
              <AlertCircle className="h-5 w-5 text-red-600 dark:text-red-400" />
            </div>
          </div>
        </CardContent>
      </Card>
      
      <Card>
        <CardContent className="p-4">
          <div className="flex justify-between items-start">
            <div>
              <p className="text-sm font-medium">Offline</p>
              <h3 className="text-2xl font-bold mt-1">{data.offline}</h3>
            </div>
            <div className="rounded-full bg-gray-100 p-2 dark:bg-gray-800">
              <Signal className="h-5 w-5 text-gray-600 dark:text-gray-400" />
            </div>
          </div>
        </CardContent>
      </Card>
      
      <Card>
        <CardContent className="p-4">
          <div className="flex justify-between items-start">
            <div>
              {type === 'smartMeters' ? (
                <>
                  <p className="text-sm font-medium">Total Readings</p>
                  <h3 className="text-2xl font-bold mt-1">{data.totalReadings}</h3>
                </>
              ) : (
                <>
                  <p className="text-sm font-medium">Data Transferred</p>
                  <h3 className="text-2xl font-bold mt-1">{data.dataTransferred?.toFixed(1)} MB</h3>
                </>
              )}
            </div>
            <div className="rounded-full bg-blue-100 p-2 dark:bg-blue-900/30">
              {type === 'smartMeters' ? (
                <Activity className="h-5 w-5 text-blue-600 dark:text-blue-400" />
              ) : (
                <Database className="h-5 w-5 text-blue-600 dark:text-blue-400" />
              )}
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default DeviceStatusCards;
